import { Checkbox, Form } from 'antd';
import Text from 'components/Text/Text';
import React from 'react';

interface IIsFeeFiscalizedCheckbox {
	settingsId: string;
	isFeeFiscalized: boolean;
	onToggleIsFeeFiscalized: () => void;
}

const IsFeeFiscalizedCheckbox: React.FC<IIsFeeFiscalizedCheckbox> = ({
	settingsId,
	onToggleIsFeeFiscalized,
	isFeeFiscalized,
}) => {
	return (
		<Form.Item data-test="IsFeeFiscalizedCheckbox" name={`isFeeFiscalized-${settingsId}`}>
			<Checkbox checked={isFeeFiscalized} onChange={onToggleIsFeeFiscalized}>
				<Text translationNameSpace="form" translationKey="isFeeFiscalizedLabel" asFragment={true} />
			</Checkbox>
		</Form.Item>
	);
};

export default React.memo(IsFeeFiscalizedCheckbox);
